import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { 
    loadClubTansterCalculate,
    loadTranferPayment,
} from '../../modules/payment/payment'
import AdminClubTransferCalculate from '../../components/admin/AdminClubTransferCalculate';

const AdminClubTransferCalculateContainer = ({history}) => {

    const dispatch = useDispatch();
    const {
        user,
        clubTransferCalculate,
        transferClubLogList,
        socketKey,
    } = useSelector(({ user, payment, socket }) => ({
        user: user.user,
      socketKey: socket.socketKey,
      clubTransferCalculate: payment.transferCalculate,
      transferClubLogList: payment.transferClubLogList,
    }));
    const [startTime, setStartTime] = useState(0)
    const [endTime, setEndTime] = useState(0)
    const [compareResults, setCompareResults] = useState([])
    const [compareSummary, setCompareSummary] = useState(null)

  useEffect(() => {
    let _startTime = startTime;
    let _endTime = endTime;
    if(_endTime == 0 && _startTime == 0)
    {
        let tempdate = new Date()
        _endTime = parseInt(tempdate.getTime()/1000);
        tempdate.setDate(1)
        tempdate.setHours(0, 0, 0, 0)
        tempdate.setMonth(tempdate.getMonth() - 5)
        _startTime = parseInt(tempdate.getTime()/1000);
        setStartTime(_startTime)
        setEndTime(_endTime)
    }
  }, [])

  useEffect(() => {
    if (user && user.playerID) {
        dispatch(loadTranferPayment({
            playerID:user.playerID,
            socketKey
        }))
    }
  }, [user, socketKey, dispatch])

  useEffect(() => {
    if (!socketKey) return;
    if (startTime === 0 || endTime === 0) return;
    dispatch(loadClubTansterCalculate({
        startTime,
        endTime,
        clubID:0,
        socketKey
    }))
    setCompareResults([])
    setCompareSummary(null)
  }, [dispatch, socketKey, startTime, endTime])


  const onClickPeriod = (period)=>{
    let tempdate = new Date()

    let _startTime = 0;
    let _endTime = parseInt(tempdate.getTime()/1000);
    if(period == 'month')
    {
        tempdate.setDate(1)
        tempdate.setHours(0, 0, 0, 0)
        _startTime = parseInt(tempdate.getTime()/1000);
    }
    else if(period == '3months')
    {
        tempdate.setDate(1)
        tempdate.setHours(0, 0, 0, 0)
        tempdate.setMonth(tempdate.getMonth() - 2)
        _startTime = parseInt(tempdate.getTime()/1000);
    }
    else if(period == '6months')
    {
        tempdate.setDate(1)
        tempdate.setHours(0, 0, 0, 0)
        tempdate.setMonth(tempdate.getMonth() - 5)
        _startTime = parseInt(tempdate.getTime()/1000);
    }
    
    setStartTime(_startTime)
    setEndTime(_endTime)
}

const onChangeStartTime = (_startTime)=>
{
    setStartTime(_startTime)
}

const onChangeEndTime = (_endTime)=>
{
    setEndTime(_endTime)
}

const normalizeDateKey = (timestamp) => {
    const date = new Date(timestamp * 1000);
    date.setHours(0, 0, 0, 0);
    const normalizedTimestamp = Math.floor(date.getTime() / 1000);
    const dateLabel = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    return { normalizedTimestamp, dateLabel };
};

const handleCompare = (filterClubID = 0) => {
    if(!clubTransferCalculate || !transferClubLogList) {
        setCompareResults([]);
        setCompareSummary(null);
        return;
    }

    const calcGroups = new Map();
    const calcTotals = {
        totalPrice: 0,
        fees: 0,
        transferPrice: 0,
    };
    clubTransferCalculate.forEach((item) => {
        if(item.registTime < startTime || item.registTime > endTime) return;
        if(filterClubID !== 0 && item.clubID !== filterClubID) return;
        const { normalizedTimestamp, dateLabel } = normalizeDateKey(item.registTime);
        const key = `${item.clubID || 0}-${dateLabel}`;
        const group = calcGroups.get(key) || {
            clubID: item.clubID,
            clubName: item.clubName,
            registDateLabel: dateLabel,
            registTimestamp: normalizedTimestamp,
            totalPrice: 0,
            fees: 0,
            transferPrice: 0,
            count: 0,
        };
        group.totalPrice += item.totalPrice || 0;
        group.fees += item.fees || 0;
        group.transferPrice += item.transferPrice || 0;
        group.count += 1;
        calcGroups.set(key, group);
        calcTotals.totalPrice += item.totalPrice || 0;
        calcTotals.fees += item.fees || 0;
        calcTotals.transferPrice += item.transferPrice || 0;
    });

    const actualGroups = new Map();
    const actualTotals = {
        totalPrice: 0,
        fees: 0,
        transferPrice: 0,
    };

    transferClubLogList.forEach((item) => {
        if(item.registTime < startTime || item.registTime > endTime) return;
        if(filterClubID !== 0 && item.clubID !== filterClubID) return;
        const { normalizedTimestamp, dateLabel } = normalizeDateKey(item.registTime);
        const key = `${item.clubID || 0}-${dateLabel}`;
        const group = actualGroups.get(key) || {
            clubID: item.clubID,
            clubName: item.clubName,
            registDateLabel: dateLabel,
            registTimestamp: normalizedTimestamp,
            totalPrice: 0,
            fees: 0,
            transferPrice: 0,
            count: 0,
        };
        group.totalPrice += item.totalPrice || 0;
        group.fees += item.fees || 0;
        group.transferPrice += item.transferPrice || 0;
        group.count += 1;
        actualGroups.set(key, group);
        actualTotals.totalPrice += item.totalPrice || 0;
        actualTotals.fees += item.fees || 0;
        actualTotals.transferPrice += item.transferPrice || 0;
    });

    const allKeys = new Set([...calcGroups.keys(), ...actualGroups.keys()]);
    const diffs = [];
    allKeys.forEach((key) => {
        const calcGroup = calcGroups.get(key) || null;
        const actualGroup = actualGroups.get(key) || null;

        const clubID = calcGroup?.clubID ?? actualGroup?.clubID ?? 0;
        const clubName = calcGroup?.clubName || actualGroup?.clubName || '';
        const registTimestamp = calcGroup?.registTimestamp ?? actualGroup?.registTimestamp ?? 0;
        const registDateLabel = calcGroup?.registDateLabel || actualGroup?.registDateLabel || '';

        const calcTotal = calcGroup
            ? {
                  totalPrice: calcGroup.totalPrice,
                  fees: calcGroup.fees,
                  transferPrice: calcGroup.transferPrice,
              }
            : { totalPrice: 0, fees: 0, transferPrice: 0 };

        const actualTotal = actualGroup
            ? {
                  totalPrice: actualGroup.totalPrice,
                  fees: actualGroup.fees,
                  transferPrice: actualGroup.transferPrice,
              }
            : { totalPrice: 0, fees: 0, transferPrice: 0 };

        const totalDiff = calcTotal.totalPrice - actualTotal.totalPrice;
        const feesDiff = calcTotal.fees - actualTotal.fees;
        const transferDiff = calcTotal.transferPrice - actualTotal.transferPrice;

        if (
            Math.abs(totalDiff) > 0 ||
            Math.abs(feesDiff) > 0 ||
            Math.abs(transferDiff) > 0
        ) {
            let status = 'mismatch';
            if (calcGroup && !actualGroup) status = 'calculation_only';
            else if (!calcGroup && actualGroup) status = 'actual_only';

            diffs.push({
                clubID,
                clubName,
                registTime: registTimestamp,
                registDateLabel,
                calculateGroup: calcGroup,
                actualGroup,
                calculateTotal: calcTotal,
                actualTotal,
                status,
                diff: {
                    totalPrice: totalDiff,
                    fees: feesDiff,
                    transferPrice: transferDiff,
                },
            });
        }
    });

    setCompareResults(diffs);
    setCompareSummary({
        calculation: calcTotals,
        actual: actualTotals,
        diff: {
            totalPrice: calcTotals.totalPrice - actualTotals.totalPrice,
            fees: calcTotals.fees - actualTotals.fees,
            transferPrice: calcTotals.transferPrice - actualTotals.transferPrice,
        },
    });
};

  return (
    <>
        <AdminClubTransferCalculate
            clubTransferCalculate={clubTransferCalculate}
            startTime={startTime}
            endTime={endTime}
            setStartTime={onChangeStartTime}
            setEndTime={onChangeEndTime}
            onClickPeriod={onClickPeriod}
            onCompare={handleCompare}
            compareResults={compareResults}
            compareSummary={compareSummary}
        />
    </>
  );
};

export default AdminClubTransferCalculateContainer;
